<template>
    <div class="main">
        <div class="license_table_box">
            <div class="top_export_custom">
                <div class="export_custom">
                    <div class="export" @click="exportLicenseList()">
                        <span class="icon-export "></span>
                        <span>导出</span>
                    </div>
                    <!-- <div class="customHeader" @click.stop="customHeader.show=!customHeader.show"> -->
                    <div class="customHeader" @click="showCustomHeaderModal">
                        <span class="icon-custom"></span>
                        <span @click="showCustomHeaderModal">自定义表头</span>
                    </div>
                </div>
            </div>
            <div class="table_modal">
                <div class="license_table_body">
                    <Table :columns="checkedToshowHeader" :data-source="tableData" ref="table"
                        :scroll="{ x: 1800 }"
                        :loading="loading"
                        :sortDirections="['descend', 'ascend']"
                        :rowKey="(record, index) => index"
                        xScrollPlacement="tableBottom"
                        :pagination="pageOpt"
                        @change="onChangeSort"
                    >
                        <template slot="licenseId" slot-scope="licenseId">
                            <a-tooltip >
                                <template slot="title">
                                    <span>{{licenseId}}</span>
                                </template>
                                <span>{{licenseId}}</span>
                            </a-tooltip>
                        </template>
                        <template slot="productTypes" slot-scope="productTypes">
                            <a-tooltip>
                                <template slot="title">
                                    <span>{{productStr(productTypes)}}</span>
                                </template>
                                <div class="col_item_text">{{productStr(productTypes)}}</div>
                            </a-tooltip>
                        </template>
                        <template slot="projectName" slot-scope="projectName">
                            <a-tooltip>
                                <template slot="title">
                                    <span>{{projectName}}</span>
                                </template>
                                <span class="ecllipsis">{{projectName}}</span>
                            </a-tooltip>
                        </template>
                        <template slot="orderNo" slot-scope="orderNo">
                            <a-tooltip>
                                <template slot="title">
                                    <span>{{orderNo}}</span>
                                </template>
                                <span class="ecllipsis">{{orderNo}}</span>
                            </a-tooltip>
                        </template>
                        <template slot="activeTime" slot-scope="activeTime">
                            <span v-if="!activeTime">--</span>
                            <span v-if="activeTime">{{activeTime}}</span>
                        </template>
                        <template slot="customerName" slot-scope="customerName">
                            <a-tooltip>
                                <template slot="title">
                                    <span v-if="customerName">{{customerName}}</span>
                                </template>
                                <div class="col_item_text">{{customerName}}</div>
                            </a-tooltip>
                            <span v-if="!customerName">--</span>
                        </template>
                        <!-- <template slot="customerName" slot-scope="customerName">
                         <a-tooltip>
                            <template slot='title'>
                              {{customerName}}
                            </template>
                            <span class="ecllipsis">
                                {{customerName}}
                            </span>
                          </a-tooltip>
                        </template> -->
                        <!-- 申请人 -->
                        <template slot="applicantName" slot-scope="applicantName">
                            <a-tooltip>
                                <template slot="title">
                                    <span v-if="applicantName">{{applicantName}}</span>
                                </template>
                                <div class="col_item_text">{{applicantName}}</div>
                            </a-tooltip>
                            <span v-if="!applicantName">--</span>
                        </template>
                        <span slot="action" class="operate" slot-scope="text, record">
                            <a :href="'/rest/mgmt/download/' + record.orderNo">下载</a>
                            <a @click="getItemDetail(record)">详情</a>
                            <a @click="sendItem(record)">发送</a>
                            <a v-if="record.activeCode" @click="copyCode(record)">复制激活码</a>
                        </span>
                    </Table>
                </div>
                <div class="license_table_footer">
                    <!-- <div class="left_total_item">共有  1234  条</div>
                      <div class="right_pagination_box">
                      </div> -->
                </div>
            </div>
        </div>
        <!-- 详情Modal -->
        <div v-if="detailmodalVisible">
            <a-modal
                    title="License详情"
                    width="520px"
                    centered
                    :visible="detailmodalVisible"
                    class="detailModal"
                    @ok="
          () => {
            this.detailmodalVisible = false;
            this.email = '';
            this.emailTipsFlag = false;
            this.activeCode = '';
          }
        "
                    @cancel="
          () => {
            this.detailmodalVisible = false;
            this.email = '';
            this.emailTipsFlag = false;
            this.activeCode = '';
          }
        "
            >
                <div class="detail_body">
                    <div
                            class="project_box clear"
                            v-for="(item, index) in detailData"
                            :key="index"
                    >
                        <div class="project_title_box clear">
                            <p class="sub_title">项目信息</p>
                            <p class="line"></p>
                        </div>
                        <div class="project_content_box ">
                            <div class="content_item">
                                <p>项目名称</p>
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <p>{{ item.projectName }}</p>
                                    </template>
                                    <p class="ellipsis_line">{{ item.projectName }}</p>
                                </a-tooltip>
                            </div>
                            <div class="two_item content_item clear" v-show="noCustomInfoFlag && item.contractNo">
                                <div class="clear">
                                    <p class="customer ">最终客户</p>
                                    <a-tooltip placement="topLeft">
                                        <template slot="title">
                                            <p>{{ item.customerName }}</p>
                                        </template>
                                        <p class="ellipsis">{{ item.customerName }}</p>
                                    </a-tooltip>
                                </div>
                                <div v-show="item.customerCode">
                                    <p>信用代码</p>
                                    <p>{{ item.customerCode }}</p>
                                </div>
                            </div>
                            <div class="two_item content_item" v-show="noCustomInfoFlag && item.contractNo">
                                <div>
                                    <p>合同编号</p>
                                    <!--<p>{{ item.contractNo }}</p> -->
                                    <a-tooltip placement="topLeft">
                                        <template slot="title">
                                            <p>{{ item.contractNo }}</p>
                                        </template>
                                        <p class="ellipsis">{{ item.contractNo }}</p>
                                    </a-tooltip>
                                </div>
                                <div>
                                    <p>合同金额</p>
                                    <p>{{ item.contractValue | formatContractValue }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="project_title_box clear">
                            <p class="sub_title">相关产品</p>
                            <p class="line"></p>
                        </div>
                        <!--License2.0 缺少单价 单价等级  数量 每小时最大会话数 最大在线探针数  无字段 -->
                        <div
                                v-show="clickEachVersion=='License_v2.0'"
                                class="project_content_box  clear"
                                v-for="(subProduct, index) in item.products"
                                :key="index"
                        >
                            <div class="related_product_box">
                                <div class="content_item related_product_title">
                                    {{ subProduct.name }}
                                </div>
                            </div>
                            <div v-if="subProduct.type == 6">
                                <div class="browser_content clear">
                                    <div class="browser_left">
                                        <div class="content_item">
                                            <p>阶段</p>
                                            <p>{{ subProduct.buyType | formatBuyType }}</p>
                                        </div>
                                        <div class="content_item" v-if="subProduct.deployType">
                                            <p>部署环境</p>
                                            <p>{{ subProduct.deployType | formatDeployType }}</p>
                                        </div>
                                    </div>
                                    <div class="browser_right">
                                        <div class="content_item">
                                            <p>License类型</p>
                                            <p>{{ subProduct.envType | formatEnvType }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!subProduct.itemList || subProduct.itemList.length == 0">
                                    <div class="browser_content clear">
                                        <div class="browser_left">
                                            <div class="content_item">
                                                <p class="validDate">计费组</p>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <p>{{subProduct.buyModeName}}</p>
                                                    </template>
                                                    <p class="ellipsis">{{subProduct.buyModeName}}</p>
                                                </a-tooltip>
                                            </div>
                                            <div class="content_item">
                                                <p>资源规格</p>
                                                <p>{{ subProduct.limitedNum | formatLimitedNum }}</p>
                                            </div>
                                            
                                        </div>
                                        <div class="browser_right">
                                            <div class="content_item">
                                                <p class="validDate">计费项</p>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <p>{{ subProduct.itemName }}<span v-if="subProduct.itemId == '42'">{{subProduct.id}}</span></p>
                                                    </template>
                                                    <p class="ellipsis">{{subProduct.itemName}}<span v-if="subProduct.itemId == '42'">{{subProduct.id}}</span></p>
                                                </a-tooltip>
                                            </div>
                                            <div class="content_item">
                                                <p class="validDate">有效期</p>
                                                <p>{{formatValidDate(subProduct.days)}}<span v-show="disabledDown">（天）</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="browser_content clear" v-for="(modeItem, index) in subProduct.itemList" :key="index">
                                        <div class="browser_left">
                                            <div class="content_item">
                                                <p class="validDate">计费组</p>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <p>{{modeItem.buyModeName}}</p>
                                                    </template>
                                                    <p class="ellipsis">{{modeItem.buyModeName}}</p>
                                                </a-tooltip>
                                            </div>
                                            <div class="content_item">
                                                <p>资源规格</p>
                                                <p>{{ modeItem.limitedNum | formatLimitedNum }}</p>
                                            </div>
                                        </div>
                                        <div class="browser_right">
                                            <div class="content_item">
                                                <p class="validDate">计费项</p>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <p>{{ modeItem.itemName }}<span v-if="modeItem.itemId == '42'">{{modeItem.id}}</span></p>
                                                    </template>
                                                    <p class="ellipsis">{{modeItem.itemName}}<span v-if="modeItem.itemId == '42'">{{modeItem.id}}</span></p>
                                                </a-tooltip>
                                            </div>
                                            <div class="content_item">
                                                <p class="validDate">有效期</p>
                                                <p>{{formatValidDate(modeItem.days)}}<span v-show="disabledDown">（天）</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="browser_content clear">
                                    <div class="browser_left">
                                        <div class="content_item" v-show="clcikItemVersion==0">
                                            <p>阶段</p>
                                            <p>{{ subProduct.buyType | formatBuyType }}</p>
                                        </div>
                                        <div class="content_item">
                                            <p>License类型</p>
                                            <p>{{ subProduct.envType | formatEnvType }}</p>
                                        </div>
                                        <div class="content_item" v-if="subProduct.days !== undefined">
                                            <p class="validDate">有效期</p>
                                            <p>{{formatValidDate(subProduct.days)}}<span v-show="disabledDown">（天）</span></p>
                                        </div>
                                        <div class="content_item"
                                            v-show="subProduct.price !== undefined && [11,21,31,51,71].indexOf(subProduct.buyMode)>=0">
                                            <p class="unit_price">单价(元)</p>
                                            <p>{{ subProduct.price > 0 ? subProduct.price/100 : 0 }}</p>
                                        </div>
                                        <div class="content_item" v-if="subProduct.deployType">
                                            <p>部署环境</p>
                                            <p>{{ subProduct.deployType | formatDeployType }}</p>
                                        </div>
                                    </div>
                                    <div class="browser_right">
                                        <div class="content_item">
                                            <p>计费模式</p>
                                            <p>{{ subProduct.buyMode | formatBuyMode }}</p>
                                        </div>
                                        <div class="content_item" v-show="clcikItemVersion==0 ">
                                            <p class="billingUnitTitle">资源</p>
                                            <p>{{subProduct.billingUnit}}</p>
                                        </div>
                                        <div class="content_item">
                                            <!-- <p class="amount">规格</p> -->
                                            <p v-show="subProduct.limitedNum">资源规格</p>
                                            <p>{{ subProduct.limitedNum|formatLimitedNum }}</p>
                                        </div>
                                        <div class="content_item"
                                            v-show="subProduct.priceLevel !== undefined && [11,21,31,51,71].indexOf(subProduct.buyMode)>=0">
                                            <p>折扣</p>
                                            <p>{{subProduct.priceLevel}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- license 1.0  规格AH资源限制 -->
                        <div
                                v-show="clickEachVersion=='License_v1.0'"
                                class="project_content_box  clear"
                                v-for="(subProduct, index) in item.products"
                                :key="'1.0'+ index"
                        >
                            <div class="related_product_box">
                                <div class="content_item related_product_title">
                                    {{ subProduct.name }}
                                </div>
                            </div>
                            <div class="browser_content">
                                <div class="browser_left">
                                    <div class="content_item">
                                        <p>阶段</p>
                                        <p>{{ subProduct.buyType | formatBuyType }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p>套餐类型</p>
                                        <p>{{subProduct.packageType | formatPackageType }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p class="specifications">规格</p>
                                        <p>Agent并发数 {{ subProduct.limitedConAgent}}</p>
                                    </div>
                                    <div class="content_item">
                                        <p>资源规格</p>
                                        <p>{{subProduct.limitedNum}}</p>
                                    </div>
                                </div>
                                <div class="browser_right">
                                    <div class="content_item">
                                        <p>计费模式</p>
                                        <p>{{ subProduct.buyMode | formatBuyMode }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p class="amount">开始时间</p>
                                        <p>{{ subProduct.validFrom }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p class="amount">结束时间</p>
                                        <p>{{ subProduct.validTo }}</p>
                                    </div>
                                    <div class="content_item" v-if=" subProduct.deployType">
                                        <p>部署环境</p>
                                        <p>{{ subProduct.deployType | formatDeployType }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- license 1.1   -->
                        <div
                                v-show="clickEachVersion=='License_v1.1'"
                                class="project_content_box  clear"
                                v-for="(subProduct, index) in item.products"
                                :key="'1.1'+ index"
                        >
                            <div class="related_product_box">
                                <div class="content_item related_product_title">
                                    {{ subProduct.name }}
                                </div>
                            </div>
                            <div class="browser_content">
                                <div class="browser_left">
                                    <div class="content_item">
                                        <p>阶段</p>
                                        <p>{{ subProduct.buyType | formatBuyType }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p>探针数量</p>
                                        <p> {{ subProduct.limitedNum}}</p>
                                    </div>
                                    <div class="content_item" v-if="subProduct.deployType">
                                        <p>部署环境</p>
                                        <p>{{ subProduct.deployType | formatDeployType }}</p>
                                    </div>
                                </div>
                                <div class="browser_right">
                                    <div class="content_item">
                                        <p>开始时间</p>
                                        <p>{{ subProduct.validFrom }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p>结束时间</p>
                                        <p>{{ subProduct.validTo }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- license 1.2   -->
                        <div
                                v-show="clickEachVersion=='License_v1.2'"
                                class="project_content_box  clear"
                                v-for="(subProduct, index) in item.products"
                                :key="'1.2'+ index"
                        >
                            <div class="related_product_box">
                                <div class="content_item related_product_title">
                                    {{ subProduct.name }}
                                </div>
                            </div>
                            <div class="browser_content">
                                <div class="browser_left">
                                    <div class="content_item">
                                        <p>阶段</p>
                                        <p>{{ subProduct.buyType | formatBuyType }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p class="specifications">月活</p>
                                        <p>{{ subProduct.limitedNum}}</p>
                                    </div>
                                    <div class="content_item" v-if="subProduct.deployType">
                                        <p>部署环境</p>
                                        <p>{{ subProduct.deployType | formatDeployType }}</p>
                                    </div>
                                </div>
                                <div class="browser_right">
                                    <div class="content_item">
                                        <p>开始时间</p>
                                        <p>{{ subProduct.validFrom }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p>结束时间</p>
                                        <p>{{ subProduct.validTo }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- license 1.3   -->
                        <div
                                v-show="clickEachVersion=='License_v1.3'"
                                class="project_content_box  clear"
                                v-for="(subProduct, index) in item.products"
                                :key="'1.3'+ index"
                        >
                            <div class="related_product_box">
                                <div class="content_item related_product_title">
                                    {{ subProduct.name }}
                                </div>
                            </div>
                            <div class="browser_content">
                                <div class="browser_left">
                                    <div class="content_item">
                                        <p>阶段</p>
                                        <p>{{ subProduct.buyType | formatBuyType }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p class="specifications">月活</p>
                                        <p>{{ subProduct.limitedNum}}</p>
                                    </div>
                                    <div class="content_item" v-if=" subProduct.deployType">
                                        <p>部署环境</p>
                                        <p>{{ subProduct.deployType | formatDeployType }}</p>
                                    </div>
                                </div>
                                <div class="browser_right">
                                    <div class="content_item">
                                        <p>开始时间</p>
                                        <p>{{ subProduct.validFrom }}</p>
                                    </div>
                                    <div class="content_item">
                                        <p>结束时间</p>
                                        <p>{{ subProduct.validTo }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- license 2.1 -->
                        <div>
                            <div
                                v-show="clickEachVersion=='License_v2.1' || clickEachVersion=='License_v2.2'"
                                class="project_content_box  clear"
                                v-for="(subProduct, index) in item.products"
                                :key="index"
                        >
                            <div class="related_product_box">
                                <div class="content_item related_product_title">
                                    {{ subProduct.name }}
                                </div>
                            </div>
                            <div class="browser_content clear">
                                <div class="browser_left">
                                    <div class="content_item">
                                        <p>阶段</p>
                                        <p>{{ subProduct.buyType | formatBuyType }}</p>
                                    </div>
                                    <div class="content_item" v-if="subProduct.deployType">
                                        <p>部署环境</p>
                                        <p>{{ subProduct.deployType | formatDeployType }}</p>
                                    </div>
                                </div>
                                <div class="browser_right">
                                    <div class="content_item">
                                        <p>License类型</p>
                                        <p>{{ subProduct.envType | formatEnvType }}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!subProduct.itemList || subProduct.itemList.length == 0">
                                <div class="browser_content clear">
                                    <div class="browser_left">
                                        <div class="content_item">
                                            <p class="validDate">计费组</p>
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <p>{{subProduct.buyModeName}}</p>
                                                </template>
                                                <p class="ellipsis">{{subProduct.buyModeName}}</p>
                                            </a-tooltip>
                                        </div>
                                        <div class="content_item">
                                            <p>资源规格</p>
                                            <p>{{ subProduct.limitedNum | formatLimitedNum }}</p>
                                        </div>
                                        
                                    </div>
                                    <div class="browser_right">
                                        <div class="content_item">
                                            <p class="validDate">计费项</p>
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <p>{{ subProduct.itemName }}<span v-if="subProduct.itemId == '42'">{{subProduct.id}}</span></p>
                                                </template>
                                                <p class="ellipsis">{{subProduct.itemName}}<span v-if="subProduct.itemId == '42'">{{subProduct.id}}</span></p>
                                            </a-tooltip>
                                        </div>
                                        <div class="content_item">
                                            <p class="validDate">有效期</p>
                                            <p>{{formatValidDate(subProduct.days)}}<span v-show="disabledDown">（天）</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="browser_content clear" v-for="(modeItem, index) in subProduct.itemList" :key="index">
                                    <div class="browser_left">
                                        <div class="content_item">
                                            <p class="validDate">计费组</p>
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <p>{{modeItem.buyModeName}}</p>
                                                </template>
                                                <p class="ellipsis">{{modeItem.buyModeName}}</p>
                                            </a-tooltip>
                                        </div>
                                        <div class="content_item">
                                            <p>资源规格</p>
                                            <p>{{ modeItem.limitedNum | formatLimitedNum }}</p>
                                        </div>
                                    </div>
                                    <div class="browser_right">
                                        <div class="content_item">
                                            <p class="validDate">计费项</p>
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <p>{{ modeItem.itemName }}<span v-if="modeItem.itemId == '42'">{{modeItem.id}}</span></p>
                                                </template>
                                                <p class="ellipsis">{{modeItem.itemName}}<span v-if="modeItem.itemId == '42'">{{modeItem.id}}</span></p>
                                            </a-tooltip>
                                        </div>
                                        <div class="content_item">
                                            <p class="validDate">有效期</p>
                                            <p>{{formatValidDate(modeItem.days)}}<span v-show="disabledDown">（天）</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>
                </div>
                <template slot="footer">
                    <a-button type="primary" @click="downloadInDetail">
                        <a :href="'/rest/mgmt/download/' + clickOrderNo" download>下载</a>
                    </a-button>
                    <a-button type="primary" @click="showEmailModal">
                        发送邮件
                    </a-button>
                    <a-button v-if="activeCode.length" type="primary" v-clipboard:copy="activeCode" v-clipboard:success="onSuccess">
                        复制激活码
                    </a-button>
                </template>
            </a-modal>
        </div>
        <!-- 邮箱Modal -->
        <div v-if="updateEmailModalVisible">
            <a-modal
                    title="修改邮箱"
                    :visible="updateEmailModalVisible"
                    width="400px"
                    centered
                    class="update_email_modal"
                    @ok="
            () => {
              this.updateEmailModalVisible = false;
              this.email = '';
              this.emailTipsFlag = false;
            }
          "
                    @cancel="
            () => {
              this.updateEmailModalVisible = false;
              this.email = '';
              this.emailTipsFlag = false;
               this.cancelQuest()
               this.isLoadingFlag=false
              this.btnDisabledFlag=false
            }
          "
            >
                <div class="update_email_body">
                    <div class="update_email_box">
                        <div class="email_text">邮箱地址</div>
                        <div class="email_input">
                            <a-input v-model.trim="email" @input="changeEmail"></a-input>
                        </div>
                    </div>
                    <div class="email_tips" v-show="emailTipsFlag">
                        <span class="tips_icon"></span>
                        <span class="tips_text">邮箱格式错误!</span>
                    </div>
                    <div class="loading" v-show="isLoadingFlag">
              <span>
                  <i></i><i></i><i></i><i></i>
              </span>
                    </div>
                </div>
                <template slot="footer">
                    <a-button class="send_email" type="primary" @click="sendEmail" :disabled="btnDisabledFlag">
                        发送
                    </a-button>
                </template>
            </a-modal>
        </div>
        <!-- 自定义表头Modal -->
        <div v-if="customHeaderVisible">
            <a-modal
                    :visible="customHeaderVisible"
                    class="custom_table_header_modal"
                    width="320px"
                    title="自定义表头"
                    @cancel="
          () => {
            this.customHeaderVisible = false;
          }
        "
            >
                <div class="custom_body_box">
                    <div class="checkbox_container">
                        <!-- <div class="left_checkbox">
                        <a-checkbox  v-for="(item,index) in customHeaderData" :key="index" :checked="isChecked" ><span class="checkbox_text">{{item.title}}</span></a-checkbox>

                        </div>
                        <div class="right_checkbox">
                            <a-checkbox :checked="isChecked"><span class="checkbox_text"></span></a-checkbox>
                        </div> -->

                        <a-checkbox
                                v-for="(item, index) in ignoreHiddenCol"
                                @change="changeSelect(item, $event)"
                                :key="index"
                                :checked="item.itemIsChecked"
                        ><span class="checkbox_text">{{ item.title }}</span></a-checkbox
                        >
                    </div>
                </div>
                <template slot="footer">
                    <a-button
                            class="confirm_table_header"
                            type="primary"
                            @click="confirmCustomHeader"
                    >
                        确定
                    </a-button>
                </template>
            </a-modal>
        </div>

    </div>
</template>

<script>
    import {
        Form,
        Input,
        Select,
        Button,
        Checkbox,
        DatePicker,
        Icon,
        Result,
        Modal,
        Tooltip,
        Table,
        Spin
    } from "ant-design-vue";
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    const {Item: FormItem} = Form;

    // import { Table } from "view-design";

    import "../../../less/common.less";
    import '../../../less/custom.less'
    import './tableList.less'
    import dayjs from "dayjs";
    import {sendEmail} from '../../../api/cancel.js'
    import manage_service from "@/model/manage_service.js";
    import user_service from "@/model/user_service";
    import axios from 'axios'
    import {exportExcel} from "@/util/excel.js";
    import exportCsv from '../../../util/exportCSV.js'

    import {createNamespacedHelpers, mapGetters} from "vuex";
    Vue.use(VueClipboard)
    const {mapActions, mapState, mapMutations} = createNamespacedHelpers(
        "manage"
    );

    // 计费模式
    const BUY_MODE = {
        11: "AH",
        12: "最大在线探针数",
        21: "US",
        22: "每小时最大会话数",
        23: "月活",
        24: "免费版",
        31: "US",
        32: "每小时最大会话数",
        33: "PV",
        34: "免费版",
        41: "企业版订阅",
        42: "免费版订阅",
        43: "私有化企业版订阅",
        44: "私有化企业版买断",
        51: "会话用量",
        71: "US",
        72: "打开次数"
    };

    const PRODUCT_TYPE_MAP = {
        1: 'Server',
        2: 'MobileSDK',
        3: 'Browser',
        4: 'Dataview',
        5: 'MP'
    }

    // 表头数据
    const columns = [
        {
            title: "License ID",
            dataIndex: "licenseId",
            key: "licenseId",
            height: 40,
        },
        {
            title: "License版本",
            dataIndex: "versionType",
            key: "versionType",
            // scopedSlots: { customRender: 'versionType' },
            // slot:"versionType"
            width: 100,
        },
        {
            title: "项目名称",
            dataIndex: "projectName",
            key: "projectName",
            width: 250,
            ellipsis: true
        },
        {
            title: "相关产品",
            dataIndex: "productTypes",
            key: "productTypes",
            // slot:"productTypes"
            // scopedSlots: { customRender: 'productTypes' },
            width: 100,
        },
        {
            title: "申请工单号",
            dataIndex: "orderNo",
            key: "orderNo",
            width: 200,
            ellipsis: true
        },
        {
            title: "申请人",
            dataIndex: "applicantName",
            key: "applicantName",
            width: 150,
        },
        {
            title: "最终客户",
            dataIndex: "customerName",
            key: "customerName",
            width: 200,
        },
        {
            title: "申请时间",
            dataIndex: "applyTime",
            key: "applyTime",
            sorter: (a, b) => {
                return Date.parse(a.applyTime) - Date.parse(b.applyTime);
            },
            defaultSortOrder: "ascend",
            sortDirections: ["descend", "ascend"],
            width: 144,
        },
        {
            title: "生效时间",
            dataIndex: "activeTime",
            key: "activeTime",
            width: 144,
        },
        {
            title: "状态",
            dataIndex: "status",
            key: "status",
            // scopedSlots: { customRender: 'status' },
            // slot:"status"
            width: 68,
        },
        {
            title: "操作",
            key: "action",
            align: "left",
            // scopedSlots: { customRender: 'action' },
            slot: "action",
        },
    ];

    export default {
        data() {
            return {
                activeCode: '',
                form: this.$form.createForm(this, {name: "license"}),
                version: "",
                dataSource: [],
                columns,
                showSearchFlag: false,
                searchContentCombindList: [],
                clickOrderNo: "",
                detailmodalVisible: false, // 默认不展示详情弹窗
                updateEmailModalVisible: false, // 默认不展示邮箱弹窗
                customHeaderVisible: false, // 默认不展示自定义表头弹窗
                email: "",
                emailTipsFlag: false, // 默认不展示邮箱错误提示
                detailData: [],
                newDetailData: [],
                defaultEmail: "",
                downUrl: "",
                downLoa: "",
                loading: true,
                allList: [],
                orderNo: "",
                checkedKeyInModal: "",
                checkedItemStatus: false,
                clcikItemVersion: "",
                confirmCustomHeaderIdList: [],
                isLoadingFlag: false,
                btnDisabledFlag: false,
                source: "",
                clickEachVersion: "",
                sortedInfo: null,
                noCustomInfoFlag: true,
                isDataViewFree: true,
                isServerTrial: true,
                disabledDown: null
            };
        },
        computed: {
            ...mapState([
                "products",
                "condition",
                "initTableData",
                "tableData",
                "total",
                "customHeaderData"
            ]),
            ...mapGetters(["formatTable"]),
            pageOpt() {
                const pagination = {
                    pageSizeOptions: ["5", "10", "20", "50", "100"],
                    defaultPageSize: 20,
                    total: this.total,
                    current: this.condition.pageNo,
                    showSizeChanger: true,
                    showTotal: total => `共有 ${total} 条`
                };
                return pagination;
            },
            // 剔除在自定义表头中部显示的字段
            ignoreHiddenCol() {
                return this.customHeaderData.filter((item) => {
                    return item.hiddenCol !== true
                });
            },
            
            // 勾选则显示表头
            checkedToshowHeader() {
                // return this.customHeaderData.filter((item) => {
                //   return item.itemIsChecked === true || item.hiddenCol==true
                // });
                let {sortedInfo} = this
                sortedInfo = sortedInfo || {}
                return this.customHeaderData.map(item => {
                    //
                    if (item.key == "applyTime") {
                        item.sortOrder = sortedInfo.columnKey === 'applyTime' && sortedInfo.order,
                            item.sorter = true
                    }
                    if (item.key == "activeTime") {
                        item.sortOrder = sortedInfo.columnKey === 'activeTime' && sortedInfo.order,
                            item.sorter = true
                    }
                    if (item.key == "createTime") {
                        item.sortOrder = sortedInfo.columnKey === 'createTime' && sortedInfo.order,
                            item.sorter = true
                    }
                    if (item.key == 'action') {
                        item.width = 200
                    }
                    return item
                }).filter((item) => {
                    return item.itemIsChecked === true || item.hiddenCol == true
                })
            },
        },
        created() {
            this.getProducts()
            // this.restState()
            // this.getTableData()
            // 初始清空上次筛选所影响的条件
            this.updateSelectCondition({
                activeTimeFrom: "",
                activeTimeTo: "",
                applicantName: "",
                applyTimeFrom: "",
                customerName: "",
                applyTimeTo: "",
                licenseId: "",
                orderNo: "",
                pageNo: 1,
                productType: 0,
                projectName: "",
                sortName: "createTime",
                sortOrder: "desc",
                status: -1,
                versionType: -1,
                pageSize: 20,
            })
            this.getAllTableData();
            this.queryCustomTableHeader()
        },
        mounted() {
            this.sortedInfo = {
                order: 'descend',
                columnKey: 'createTime'
            }
        },

        methods: {
            ...mapActions([
                "getProducts",
                "getTableData",
                "getInitTableData",
                "queryDetailByOrderNo",
                "sendEmailByOrderNo",
                "downloadByOrderNo",
                "queryCustomTableHeader",
                "exportTable"
            ]),
            ...mapMutations([
                "changeVersion",
                "changePageSize",
                "changeItemCheckboxStatus",
                "updateSelectCondition"
            ]),
            productStr(idsStr, splitStr = ',') {
                let product = ''
                return idsStr.split(',').reduce((pre, cur) => {
                    product = this.products.filter(item => String(item.productId) == String(cur))
                    if (product.length > 0) return pre == '' ? product[0].productName : pre = pre + splitStr +  product[0].productName
                    else return pre+=''
                }, '')
            },
            // 格式化有效期
            formatValidDate(days) {
                if (days == undefined) {
                    return days = '永久有效'
                }
                if (days < 0) {
                    return days = '-'
                }
                return days;
            },
            copyCode(record) {
	            this.$copyText(record.activeCode).then(
		        res => {
		          this.$message.success('复制成功', 1)
		        },
		        err => {
		          this.$message.error("复制失败");
		        }
		      )
            },
            onSuccess () {
                this.$message.success('复制成功', 1)
            },
            async getAllTableData() {
                // let res = await this.getInitTableData();
                this.loading = true;
                let res = await this.getTableData();
                this.loading = false;
                this.allList = res?.results;
            },

            // 点击表格的排序

            onChangeSort(pagination, filters, sorter) {

                this.sortedInfo = sorter
                if (sorter.order) {
                    this.order = sorter.field || 'createTime'
                    this.sort = sorter.order === 'ascend' ? 'asc' : 'desc'
                } else {
                    this.order = ''
                    this.sort = ''
                }
                if (pagination.pageSize !== this.condition.pageSize) {
                    // this.currentPage = 1
                    // this.pageSize = pagination.pageSizegetItemDetai
                    this.updateSelectCondition({pageSize: pagination.pageSize, pageNo: 1})
                } else {
                    // this.currentPage = pagination.current
                    // this.pageSize = pagination.pageSize
                    this.updateSelectCondition({pageSize: pagination.pageSize, pageNo: pagination.current})
                }
                this.updateSelectCondition({
                    sortName: this.order,
                    sortOrder: this.sort
                })

                this.update()
            },
            // 点击详情  查看每一行的信息
            getItemDetail(item) {
                this.clickEachVersion = item.versionType
                this.defaultEmail = item.applicantEmail;
                this.clickOrderNo = item.orderNo;
                this.orderNo = item.orderNo;
                this.clcikItemVersion = item.originType; // license2.0
                let clickOrderNo = item.orderNo;
                let params = {orderNo: clickOrderNo};
                this.queryDetailByOrderNo(params).then((result) => {
                    console.log('%c 🍕 result: ', 'font-size:20px;background-color: #FCA650;color:#fff;', result);
                    this.detailData = [result];
                    if(result && result.activeCode){
                        this.activeCode = result.activeCode
                    }
                    //  this.newDetailData =this.detailData[0].products.map(item=>{
                    //    item["billingUnit"]="";
                    //   return item
                    // })
                    //
                });
                // DateView免费版和Sevrer试用版无客户信息
                if (item.orderNo.indexOf('PLT') > -1) {
                    //
                    this.noCustomInfoFlag = false
                } else {
                    this.noCustomInfoFlag = true
                }
                let dataViewFreeReg = /^PLT_4/;
                let serverTrialReg = /^PLT_1/

                if (dataViewFreeReg.test(item.orderNo)) {
                    this.isDataViewFree = false;
                    this.disabledDown = false
                }

                if (serverTrialReg.test(item.orderNo)) {
                    this.isServerTrial = false
                    this.disabledDown = false
                }


                this.detailmodalVisible = true;
            },

            // 导出
            exportLicenseList() {
                // 调用接口 pageSize 2000
                let params = {
                    ...this.condition,
                    pageSize: 2000,
                    isExport: true
                }
                this.exportTable(params).then(result => {
                    var res = result.results
                    if (res.length) {
                        res.forEach((item) => {
                            if (item.orderNo || item.licenseId) {
                                item.orderNo = "\t" + item.orderNo;
                                item.licenseId = "\t" + item.licenseId;
                            }
                            if (item.status == 0) {
                                item.status = "未激活";
                            } else if (item.status == 1) {
                                item.status = "已激活";
                            }
                            if (item.versionType == 0) {
                                item.versionType = "License_v2.0";
                                item.originType = 0
                            } else if (item.versionType == 1) {
                                item.versionType = "License_v1.0";
                            } else if (item.versionType == 2) {
                                item.versionType = "License_v1.1";
                            } else if (item.versionType == 3) {
                                item.versionType = "License_v1.2";
                            } else if (item.versionType == 5) {
                                item.versionType = 'License_v2.1'
                            } else if (item.versionType == 6) {
                                item.versionType = 'License_v2.2'
                            } else {
                                item.versionType = "License_v1.3";
                            }
                            item.productTypes = this.productStr(item.productTypes, '、')
                            if (item.activeTime == null) {
                                item.activeTime = ""
                            }
                            return item;
                        })
                    }
                    let headerArr = []
                    let header = this.checkedToshowHeader.map(e => e.title).join(',').replace(',操作', '') + '\n';

                    let filterOperateCol = header;
                    const keys = this.checkedToshowHeader.map(e => e.dataIndex)
                    let cvsData = ''
                    res.forEach(e => {
                        cvsData += keys.reduce((res, current) => {
                            if (current === undefined || current === null) {
                                return (res += ',')
                            } else {
                                return (res += `${e[current]},`)
                            }
                        }, '')
                        cvsData += '\n'
                    })
                    cvsData = header + cvsData
                    exportCsv(cvsData, this.tableName)
                })
            },
            // 点击自定义表头
            showCustomHeaderModal() {
                this.customHeaderVisible = true;

            },
            changeEmail() {
                if (this.email) {
                    // 已经输入
                } else {
                    this.$message.error("邮箱不能为空");
                }
            },

            // 表格每一行的发送
            sendItem(item) {
                //
                this.defaultEmail = item.applicantEmail;
                this.clickOrderNo = item.orderNo;


                this.email = this.defaultEmail;
                this.updateEmailModalVisible = true;
            },

            // 点击表格每一行的  下载
            // download(text,record) {
            //
            //
            //   // this.clickOrderNo = item.orderNo;
            //   // this.orderNo= item.orderNo;

            //   // let orderNo = item.orderNo;
            //   // this.orderNo = orderNo;

            // },

            // 点击发送邮箱，展示邮箱地址弹窗
            showEmailModal() {

                if (this.defaultEmail) {
                    this.email = this.defaultEmail;
                }
                this.updateEmailModalVisible = true;

            },

            // 点击二次弹窗中的发送
            sendEmail() {
                // this.checkEmailValid()
                // let emailReg = /[0-9a-zA-Z]{1,16}@[0-9a-zA-Z+\.com]/;
                var emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

                if (emailReg.test(this.email)) {
                    this.emailTipsFlag = false;
                    let params = {
                        email: this.email,
                        orderNo: this.clickOrderNo,
                    };
                    // this.isLoadingFlag=true
                    // this.btnDisabledFlag=true
                    // this.sendEmailByOrderNo(params).then((result) => {

                    //
                    //   if (result === true) {

                    //     this.isLoadingFlag=false
                    //     this.$message.success("发送成功");
                    //     this.btnDisabledFlag=false
                    //     this.updateEmailModalVisible = false;
                    //   }
                    //   else if(result.id == "SERVER_BUSINESS"){
                    //     this.$message.error("该邮箱不存在");
                    //     this.isLoadingFlag=false;
                    //     this.btnDisabledFlag=false
                    //   }
                    //   else{
                    //     this.isLoadingFlag=false;
                    //     this.btnDisabledFlag=false
                    //     this.$message.error("发送失败");
                    //   }
                    // });
                    this.isLoadingFlag = true
                    this.btnDisabledFlag = true
                    sendEmail(params, this).then(result => {


                        if (result === true) {
                            this.isLoadingFlag = false
                            this.$message.success("发送成功");
                            this.btnDisabledFlag = false;
                            this.isLoadingFlag = false;
                            this.updateEmailModalVisible = false;
                        } else if (result.id == "SERVER_BUSINESS") {
                            this.$message.error("该邮箱不存在");
                            this.isLoadingFlag = false;
                            this.btnDisabledFlag = false
                        } else {
                            this.isLoadingFlag = false;
                            this.btnDisabledFlag = false
                            this.$message.error("发送失败,请重试");
                        }
                    })

                } else {
                    // this.$message.error("邮箱不合法");
                    this.emailTipsFlag = true;
                }
            },

            // 取消发送邮件
            cancelQuest() {
                if (typeof this.source === 'function') {
                    this.source('终止请求'); //取消请求
                }
            },


            // 点击二次弹窗中的下载
            downloadInDetail() {
                //
            },
            // 校验邮箱格式，并调用接口
            checkEmailValid() {
            },

            async update() {
                let params = this.condition;
                let res = await this.getTableData(params);
                if (res.id || res.msg) {
                    this.$message.error(res.data.msg, 1);
                } else {
                }
            },

            // 勾选自定义表头Modal中的复选框
            changeSelect(item, e) {


                item.itemIsChecked = e.target.checked;

                // this.changeItemCheckboxStatus({key:item.key,targetStatus:e.target.checked})
                this.checkedKeyInModal = item.key;
                item.id = item.key
                this.checkedItemId = item.id;
                this.checkedItemStatus = e.target.checked;
                var obj = {}
                obj.id = item.id;
                obj.status = e.target.checked;

                this.confirmCustomHeaderIdList.push(obj)

                // this.confirmCustomHeaderIdList=[]
                // if(e.target.checked===true){
                //  this.confirmCustomHeaderIdList.push(this.checkedItemId)
                //
                // }
                // else{
                //   // this.confirmCustomHeaderIdList.splice(item.id,1)
                //   this.confirmCustomHeaderIdList.remove(item.id)
                //
                // }
                let params = {
                    key: item.key,
                    targetStatus: e.target.checked
                }
                // this.changeItemCheckboxStatus(params)

            },

            // 确定所选自定义表头
            confirmCustomHeader() {
                // let id=this.checkedItemId;

                let itemIsChecked = this.checkedItemStatus;
                for (var item of this.confirmCustomHeaderIdList) {


                    manage_service.updateCustomHeader(item.id, {itemIsChecked: item.status}).then(result => {

                    })
                }

                let params = {
                    key: this.checkedKeyInModal,
                    targetStatus: this.checkedItemStatus,
                };
                // this.changeItemCheckboxStatus(params);
                this.customHeaderVisible = false;

            },
        },
        filters: {
            formarValidDate(dateStr) {
                return dayjs(dateStr).format("YYYY/MM/DD");
            },
            formatBuyType(buyType) {
                if (buyType == 1) {
                    return '正式'
                } else if (buyType == 2) {
                    return 'POC'
                }  else if (buyType == 3) {
                    return '试用'
                }  else if (buyType == 4) {
                    return '交付'
                }  else if (buyType == 5) {
                    return '服务'
                } else if (buyType == 6) {
                    return '功能验证'
                } else {
                    return '试用'
                }
                return buyType;
            },
            formatLimitedNum(limitedNum) {
                if (limitedNum == undefined) return '-' 
                switch (limitedNum) {
                    case -2:
                        return '>1PB'
                    case -3:
                        return '>15TB'
                    default:
                        return limitedNum
                }
            },
            formatBuyMode(buyMode) {
                return BUY_MODE[buyMode]
                //
                // if (buyMode == 1) {
                //     buyMode = "订阅式";
                // } else if (buyMode == 2) {
                //     buyMode = "买断式";
                // } else if (buyMode == 3) {
                //     buyMode = "买断式B版";
                // } else {
                //     buyMode = "接口无字段";
                // }
                // return buyMode;
            },
            formatEnvType(EnvType) {

                if (EnvType == 1) {
                    EnvType = '测试'
                } else if (EnvType == 2) {
                    EnvType = '生产'
                } else if (EnvType == 3) {
                    EnvType = 'POC'
                } else if (EnvType == 4) {
                    EnvType = '正式'
                } else if (EnvType == 5) {
                    EnvType = '续约'
                } else if (EnvType == 6) {
                    EnvType = '功能验证'
                } else {
                    EnvType = '测试'
                }
                return EnvType;
            },  
            // 格式化部署环境
            formatDeployType(deployType) {
                if (deployType == 1) {
                    return deployType = '私有化'
                } else if (deployType == 2) {
                    return deployType = 'SaaS'
                }
                return deployType;
            },


            formatBillingUnit(name, buyMode, pricingUnit) {
                if (name.indexOf('SDK') && buyMode == 1) {
                    pricingUnit == "US"
                    return pricingUnit
                }
            },
            formatContractValue(contractValue) {
                return contractValue / 100;
            },
            // 格式化license1.0 套餐类型
            formatPackageType(packageType) {
                if (packageType == 1) {
                    return packageType = '入门资源包'
                } else if (packageType == 2) {
                    return packageType = '初级资源包'
                } else if (packageType == 3) {
                    return packageType = '中级资源包'
                } else if (packageType == 4) {
                    return packageType = '高级资源包'
                } else if (packageType == 5) {
                    return packageType = '黄金资源包'
                } else if (packageType == 6) {
                    return packageType = '铂金资源包'
                } else if (packageType == 7) {
                    return packageType = '至尊资源包'
                } else {
                    return packageType = ''
                }
            }

        },
        components: {
            Table,
            Form,
            FormItem,
            "a-input": Input,
            Button,
            "a-select": Select,
            "a-select-option": Select.Option,
            "a-date-picker": DatePicker,
            "a-range-picker": DatePicker.RangePicker,
            "a-icon": Icon,
            "a-modal": Modal,
            "a-button": Button,
            "a-checkbox": Checkbox,
            "a-tooltip": Tooltip,
            "a-spin": Spin,
            // Pagination,
        },
    };
</script>
<style lang="less" scoped>
.operate{
    padding: 0px 16px;
}
</style>
